import { Box, BoxProps } from "@vinomofo/components";

import { GatsbyImage } from "gatsby-plugin-image";
import { StorefrontImage } from "../../types";
import styled from "styled-components";

const Container = styled(Box)<{ isExpired: boolean }>`
  opacity: ${({ isExpired }) => (isExpired ? 0.75 : 1)};
  ${({ isExpired }) => (isExpired ? "filter: grayscale(100%);" : "")}
`;
export interface RoundelProps extends BoxProps {
  image: StorefrontImage;
  isExpired?: boolean;
}

export const Roundel = ({
  image,
  isExpired,
  ...rest
}: RoundelProps): JSX.Element => {
  return (
    <Container
      isExpired={isExpired}
      display="flex"
      alignItems="center"
      position="absolute"
      overflow="hidden"
      borderRadius="50%"
      {...rest}
    >
      <GatsbyImage
        alt=""
        image={image}
        objectFit="cover"
        objectPosition="center center"
        style={{
          position: "absolute",
          zIndex: -1,
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
        }}
      />
    </Container>
  );
};
